import { z } from 'zod';
import { LocalDate } from './common.js';
import { Category } from './enums.js';
export const Settings = z
    .object({
    /** avviso in home, in markdown (sanificato in rendering) */
    alertHome: z.string().max(2000).optional(),
})
    .meta({ id: 'Settings' });
export const Banner = z
    .object({
    id: z.string(),
    placement: z.enum(['home_top', 'home_middle', 'list', 'event']),
    link: z.url(),
    imageMobile: z.string(),
    imageDesktop: z.string(),
    alt: z.string().max(200),
    sponsored: z.boolean().default(false),
    startDate: LocalDate.optional(),
    endDate: LocalDate.optional(),
    weight: z.int().min(0).default(1),
})
    .meta({ id: 'Banner' });
export const Service = z
    .object({
    id: z.string(),
    title: z.string(),
    description: z.string(),
    picture: z.string(),
    offering: z.string(),
    emailSubject: z.string(),
    /** indirizzo per le richieste di informazioni (default: email del sito) */
    email: z.email().optional(),
    /** sito del servizio (es. partner) e testo del pulsante */
    link: z.url().optional(),
    linkLabel: z.string().max(40).optional(),
    order: z.int().default(0),
})
    .meta({ id: 'Service' });
export const Collection = z
    .object({
    id: z.string(),
    title: z.string(),
    slug: z.string(),
    categories: z.array(Category).default([]),
    tags: z.array(z.string()).default([]),
    visibleFrom: LocalDate,
    visibleUntil: LocalDate,
    color: z.string().optional(),
})
    .meta({ id: 'Collection' });
//# sourceMappingURL=config.js.map